<template>
    <div class="alert-large alert-large-info">
      <div class="icon-container">
        <i class="fa fa-calendar"></i>
      </div>
      <div class="alert-content">
        <div class="row">
          <div class="col-sm-6">
            <p class="lead m-b-none">Admin Mark As Complete</p>
            <p class="no-margin">
              This will mark the booking as complete. Essentially closing the booking.
            </p>
          </div>
          <div class="col-sm-6">
            <button
                    class="btn btn-lg btn-success btn-job-complete"
                    @click="handleMarkBookingCompleteCallback">
              <i class="fa fa-check"></i> Mark As Complete
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { notify } from 'utils'
import { helpers } from 'mixins/bookings'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  computed: {
    ...mapState('booking', ['booking']),

    talentCanMarkAsCompleteInPerson () {
      return this.booking.talent[0].response.attendance_confirmed
    },

    talentCanMarkAsCompleteOnline () {
      return this.booking.talent[0].response.online_participation_confirmed
    }
  },

  methods: {
    ...mapActions('booking', ['getBooking', 'markBookingComplete']),

    handleMarkBookingCompleteCallback (type) {
      let payload = {
        id: this.booking.id,
        type: type
      }

      return this.markBookingComplete(payload)
        .then(() => {
          notify.success('Booking has been marked as complete.')
          this.trackEvent(this.analytics.V2.JobBookingCompleteEvent)
          // Get the updated booking resource since the talent's response has changed
          this.getBooking({ id: this.booking.id })
        })
    }
  }
}
</script>
